import React from "react";

export default function SmsEditor({ value, onChange }) {
  const length = value && value.length;
  return (
    <div>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={6}
        style={{ width: "100%", fontFamily: "monospace" }}
      />

      <div style={{ fontSize: 12, color: length > 160 ? "red" : "#666" }}>
        {length} characters
        {length > 160 && " (may be split into multiple SMS)"}
      </div>
    </div>
  );
}
